import * as types from '../constants/ActionTypes';
import client from '../lib/frost-web-client';
import logout from '../lib/logout';

//CORPORATIONS
export function requestCorpList() {
	return { type: types.REQUEST_CORP_LIST };
}

export function receiveCorpList(list) {
	return { type: types.RECEIVE_CORP_LIST, list };
}

export function receiveCorpListError(error) {
	return { type: types.RECEIVE_CORP_LIST_ERROR, error };
}

export function fetchCorpList(params) {

	return dispatch => {

		dispatch(requestCorpList());

		return client.get('/api/corporations/', params)
			.then(response => dispatch(receiveCorpList(response.body)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveCorpListError(error.response));
				}
			});
	};
}


//SELECT SINGLE CORP
export function requestCorp() {
	return { type: types.REQUEST_CORP };
}

//AKA SELECT CORP
export function receiveCorp(corporation) {
	return { type: types.RECEIVE_CORP, corporation };
}

export function receiveCorpError(error) {
	return { type: types.RECEIVE_CORP_ERROR, error };
}

export function fetchSelectedCorporation(corporationId) {

	return dispatch => {

		dispatch(requestCorp());

		return client.get('/api/corporations/' + corporationId, {})
			.then(response => dispatch(receiveCorp(response.body)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveCorpError(error.response));
				}
			});
	};
}

//CORP EDIT
export function submitEditCorporation(corporation, key) {
	return { type: types.SUBMIT_EDIT_CORP, key };
}

export function resolveEditCorporation(corporation, key) {
	let success = {
		message: 'Corporation edited.'
	};
	return { type: types.RESOLVE_EDIT_CORP, success, corporation, key };
}

export function resolveEditCorporationError(error, key) {
	return { type: types.RESOLVE_EDIT_CORP_ERROR, error, key };
}

export function editCorporation(corporation, key) {
	return dispatch => {

		dispatch(submitEditCorporation(corporation, key));

		return client.put('/api/corporations/' + corporation.id, corporation)
			.then(response => dispatch(resolveEditCorporation(corporation, key)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(resolveEditCorporationError(error.response.body, key));
				}
			});
	};
}

// CORP CLEAR STATE
export function clearCorporationState() {
	return { type: types.CLEAR_CORP_STATE };
}

//CORP CREATE
export function submitCreateCorporation(key) {
	return { type: types.SUBMIT_CREATE_CORP, key };
}

export function resolveCreateCorporation(key) {
	return { type: types.RESOLVE_CREATE_CORP, key };
}

export function resolveCreateCorporationError(error, key) {
	return { type: types.RESOLVE_CREATE_CORP_ERROR, error, key };
}

export function createCorporation(corporation, key) {
	return dispatch => {

		dispatch(submitCreateCorporation(key));

		return client.post('/api/corporations/', corporation)
			.then(response => dispatch(resolveCreateCorporation(key)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(resolveCreateCorporationError(error.response.body, key));
				}
			});
	};
}

//CORP AUTO-COMPLETE
export function requestAutoCompleteCorporationList(key) {
	return { type: types.REQUEST_AUTO_COMPLETE_CORP_LIST, key };
}

export function receiveAutoCompleteCorporationList(results, key) {
	return { type: types.RECEIVE_AUTO_COMPLETE_CORP_LIST, results, key };
}

export function receiveAutoCompleteCorporationListError(error, key) {
	return { type: types.RECEIVE_AUTO_COMPLETE_CORP_LIST_ERROR, error, key };
}

export function fetchAutoCompleteCorporationList(name, number, key) {
	return dispatch => {

		dispatch(requestAutoCompleteCorporationList(key));

		return client.get('/api/corporations', { name, number, limit: 10, offset: 0 })
			.then(response => dispatch(receiveAutoCompleteCorporationList(response.body.results, key)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveAutoCompleteCorporationListError(error.response, key));
				}
			});
	};
}

//CORP LINK
export function submitLinkCorporation(key) {
	return { type: types.SUBMIT_LINK_CORP, key };
}

export function resolveLinkCorporation(key) {
	return { type: types.RESOLVE_LINK_CORP, key };
}

export function resolveLinkCorporationError(error, key) {
	return { type: types.RESOLVE_LINK_CORP_ERROR, error, key };
}

export function linkCorporation(corporationId, feedId, key) {
	return dispatch => {

		dispatch(submitLinkCorporation(key));

		return client.post('/api/corporation-feeds/', { corporationId, feedId })
			.then(() => dispatch(resolveLinkCorporation(key)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(resolveLinkCorporationError(error, key));
				}
			});
	};
}

//CORP UNLINK
export function submitUnlinkCorporation(key) {
	return { type: types.SUBMIT_UNLINK_CORP, key };
}

export function resolveUnlinkCorporation(key) {
	return { type: types.RESOLVE_UNLINK_CORP, key };
}

export function resolveUnlinkCorporationError(error, key) {
	return { type: types.RESOLVE_UNLINK_CORP_ERROR, error, key };
}

export function unlinkCorporation(corporationId, feedId, key) {
	return dispatch => {

		dispatch(submitUnlinkCorporation(key));

		return client.del(`/api/corporation-feeds/${corporationId}/${feedId}`)
			.then(() => dispatch(resolveUnlinkCorporation(key)))
			.catch(error => {
				if (error.status === 404) {
					error.message = 'The corporation is already unlinked.';
				}
				if (!logout(error, dispatch)) {
					dispatch(resolveUnlinkCorporationError(error, key));
				}
			});
	};
}




// WEBPACK FOOTER //
// ./src/assets/js/actions/corporations.js